import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import ContactInfo from "../../components/pages/Vacancies/ContactInfo/ContactInfo";

const VacanciesPage: React.FC = () => {
  return (
    <Layout>
      <ContactInfo />
      <Feedback />
    </Layout>
  );
};

export default VacanciesPage;
